import { cn } from "../../../utils/classnames";

// Same soft badge treatment the booking list uses for its payment-status column,
// exposed as named tones so every admin table reads the same way.
export const BADGE_TONES = {
  success: "tw:bg-[#DFF9F7] tw:!text-[#3CAEA3]",
  warning: "tw:bg-[#FFFAF0] tw:!text-[#F2AE09]",
  danger: "tw:bg-[#FDECEA] tw:!text-[#EA4335]",
  info: "tw:bg-[#EAF2FA] tw:!text-[#20639B]",
  purple: "tw:bg-[#F5EEFF] tw:!text-[#8F5CD1]",
  gold: "tw:bg-[#FBF3E0] tw:!text-[#A3780F]",
  neutral: "tw:bg-[#F3F3F3] tw:!text-[#8D8D8D]",
};

const AdminBadge = ({ tone = "neutral", className, children }) => (
  <span
    className={cn(
      "tw:flex tw:h-[40px] tw:w-full tw:items-center tw:justify-center tw:whitespace-nowrap tw:rounded-[5px] tw:px-4 tw:text-[14px] tw:leading-[22px]",
      BADGE_TONES[tone] || BADGE_TONES.neutral,
      className,
    )}
  >
    {children}
  </span>
);

export default AdminBadge;
